import { COLORS, SCREEN_MD } from "shared/consts";
import { adaptiveValue, toEm, toRem } from "shared/helpers";
import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100dvh;
  display: flex;
  justify-content:center;
  align-items: safe center;
  background-color: ${COLORS.BG.SURFACE3};
  overflow: hidden auto;
  padding: ${toRem(20)};

  @media (width < ${toEm(SCREEN_MD)}){
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;
  }
`;

export const LoginWindow = styled.form`
  background-color: ${COLORS.BG.PAGE};
  padding-top: ${toRem(32)};
  padding-bottom: ${toRem(32)};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${adaptiveValue("border-radius", 32, 28, 1440, 360)}
  ${adaptiveValue("padding-left", 32, 16, 1440, 360)}
  ${adaptiveValue("padding-right", 32, 16, 1440, 360)}


  @media (width >= ${toEm(SCREEN_MD)}){
  width: ${toRem(374)};
}
  @media (width < ${toEm(SCREEN_MD)}){
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    min-height: 69dvh;
    overflow: auto;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  line-height: ${24 / 20};
  font-size: ${toRem(20)};
  &:not(:last-child) {margin-bottom: ${toRem(32)};}
`

export const SwitchersParent = styled.div`
  padding: ${toRem(2)};
  background-color: ${COLORS.BG.SURFACE3};
  align-self: stretch;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-radius: ${toRem(12)};
  position: relative;
  &:not(:last-child) {margin-bottom: ${toRem(32)};}

  i {
    position: absolute;
    top: ${toRem(2)};
    left: ${toRem(2)};
    width: calc(50% - ${toRem(2)});
    height: calc(100% - ${toRem(4)});
    border-radius: ${toRem(10)};
    background-color: ${COLORS.BG.PAGE};
    transition: translate 0.3s ease 0s;
    translate: calc(100% * var(--translate, 0));
  }
`

export const Switcher = styled.div`
  height: ${toRem(48)};
  font-weight: 500;
  font-size: ${toRem(16)};
  line-height: ${18 / 16};
  display: flex;
  justify-content:center;align-items: center;
  position: relative;
  cursor: pointer;
`

export const BlockedMessage = styled.div`
  width: 100%;
  margin-bottom: ${toRem(24)};
  padding: ${toRem(12)} ${toRem(14)};
  border: 1px solid ${COLORS.ERROR.CONTAINER_HOVER};
  border-radius: ${toRem(12)};
  background-color: ${COLORS.ERROR.CONTAINER_SOFT};
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(14)};
  line-height: ${20 / 14};

  a {
    color: ${COLORS.ERROR.DEFAULT};
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: ${toRem(2)};
  }
`

export const RecoveryButton = styled.a`
  text-decoration: underline;
  cursor: pointer;
  transition: color .3s ease-in-out;
  
  &:hover {
    color: ${COLORS.ACCENT.DEFAULT};
  }
`
